import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "../../http/axios";
import SearchForm from "../UI/SearchForm";
import { links } from "../../utils/constants";
import Pagination from "../UI/Pagination";
import { getOrders } from "../../store/actions";
import moment from "moment";
import { convertByTimeZone } from "../../utils/utils";

class Orders extends Component {
  state = {
    currentPage: 1,
    searchValue: null
  };

  componentDidMount() {
    this.getOrders();
  }

  getOrders = () => {
    const page = this.state.currentPage;
    const searchValue = this.state.searchValue;

    this.props.getOrders(page, searchValue);
  };

  goToOrderPage = id => {
    this.props.history.push(links.order(id));
  };

  pageChangeHandler = page => {
    this.setState({ currentPage: page + 1 });
    this.props.getOrders(page.selected + 1, null);
  };

  onSubmitSearchHandler = searchValue => {
    console.log(searchValue);
    this.props.getOrders(this.state.currentPage, searchValue);
  };

  onSearchChangeHandler = () => {};

  getCSV = () => {
    axios({
      url: "/orders/?show_all=true",
      method: "GET",
      headers: {
        Authorization: "JWT " + this.props.token,
        Accept: "text/csv"
      },
      responseType: "blob"
    }).then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Orders.csv");
      link.click();
    });
  };

  render() {
    let ordersTable = null;
    const { orders } = this.props;

    if (orders) {
      ordersTable = orders.map(order => {
        const { id } = order;
        const { created } = order;
        const time = moment(new Date(created)).format("hh:mm");
        return (
          <tr key={order.id} onClick={() => this.goToOrderPage(id)}>
            <td>{id}</td>
            <td>{order.initiator}</td>
            <td>
              <span className="mr-15">
                {moment(order.created).format("YYYY-MM-DD")}
              </span>
              <span>{time}</span>
            </td>
            <td>
              <span>{order.order_sum}</span> SAR
            </td>
            <td>{order.status}</td>
            <td>{order.delivery_time}</td>
            <td>{order.restaurant_name}</td>
          </tr>
        );
      });
    }

    let pagination = null;
    if (this.props.ordersPageCount > 1) {
      pagination = (
        <Pagination
          pageChangeHandler={this.pageChangeHandler}
          driversPageCount={this.props.ordersPageCount}
        />
      );
    }
    return (
      <React.Fragment>
        <div className="page-title">
          <div className="container">
            <div className="row flex-center-y justify-between">
              <div className="col-xs-9">
                <h1 className="color-grey">Orders</h1>
              </div>
              <SearchForm
                onChange={this.onSearchChangeHandler}
                onSubmit={this.onSubmitSearchHandler}
                col={3}
              />
            </div>
          </div>
        </div>
        <div className="container box py-15">
          <div className="table customerList withHover">
            <table>
              <thead>
                <tr>
                  <th>Order ID</th>
                  <th>Order App Initiator</th>
                  <th>Order Date/Time</th>
                  <th>Total Order Cost</th>
                  <th>Order status</th>
                  <th>Defined Delivery Time</th>
                  <th>Pick-up Restaurant Name</th>
                </tr>
              </thead>
              <tbody>{ordersTable}</tbody>
            </table>
          </div>
          <div className="text-right mt-20">
            <a
              style={{ cursor: "pointer" }}
              className="flex-align-y font-sm w-800"
              onClick={this.getCSV}
            >
              <i className="fa fa-download mr-10" />
              Download Excel File
            </a>
          </div>
          {pagination}
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    orders: state.operations.orders,
    token: state.auth.token,
    ordersPageCount: state.operations.ordersPageCount
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getOrders: (page, searchValue) => dispatch(getOrders(page, searchValue))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Orders);



// WEBPACK FOOTER //
// ./src/components/Operation-room/Orders.js